export const questionsData = {
  1: {
    name: "Scope 1. Direct Emissions",
    icon: "🔥",
    maxPoints: 5,
    maxQuestions: 4,
    categories: [
      {
        categoryId: "S1-C1",
        categoryName: "Energy emissions burned onsite",
        questions: [
          {
            questionId: 1,
            text: "1. Select from the answers below,  which energy end-use is currently utilizing {{tooltip:Fossil Fuels|Fossil Fuels = Natural Gas, Diesel, Charcoal, Petrol}}",
            helperText: " (Select only one answer)", 
            type: "single",
            options: [
              { label: "Not applicable - The hotel does not use Fossil Fuels", points: 2,answerCount:1 },
              { label: "Fossil fuels used in the kitchen for Cooking", points: 1,answerCount:1 },
              { label: "Fossil fuels used for Hot water heating", points: 1 },
              { label: "Fossil fuels used for Space heating (i.e. radiators)", points: 1 ,answerCount:1},
              { label: "Fossil fuels used for both Cooking and Hot Water heating", points: 0 ,answerCount:1},
              { label: "Fossil fuels used for both Cooking and Space heating", points: 0,answerCount:1 },
              { label: "Fossil fuels used for both Space heating and Hot Water heating", points: 0 ,answerCount:1},
              { label: "Fossil fuels used in Back-up  energy Generators", points: 0 ,answerCount:1},
              { label: "Other - Please indicate other energy end-uses that run on fossil fuels", points: 0, other: true ,answerCount:1}
            ]
          }
        ]
      },
      {
        categoryId: "S1-C2",
        categoryName: "{{tooltip:Fugitive emissions|Fugitive emissions are gas or vapor leaks that escape unintentionally from equipment or pipes.}}",
        questions: [
          {
            questionId: 2,
            text: "2. Select the answer that best applies, regarding fugitive emissions in the HVAC (Heating Ventilation and Air Conditioning) system.",
            helperText: "(Select only one answer)", 
            type: "single",
            options: [
              { label: "The hotel is connected to a District Cooling plant and does not have any refrigerant equipment on site for HVAC such as AC units", points: 1,answerCount:1 },
              { label: "The hotel uses VRV for Heating/Cooling as part of the HVAC system. The refrigerants used are:", points: 1, other: true ,answerCount:1},
              { label: "A chiller(s) is used for space cooling: Natural Refrigerant ", points: 1, other: true ,answerCount:1},
              { label: "A chiller(s) is used for space cooling: Non-natural or Unknown Refrigerant", points: 0 ,answerCount:1}
            ]
          }
        ]
      },
      {
        categoryId: "S1-C3",
        categoryName: "Hotel Equipment",
        questions: [
          {
            questionId: 3,
            text: "3. Select the answer that best applies, regarding hotel equipment that uses fossil fuels.",
            helperText: "(Select multiple options)", 
            type: "multi",
            options: [
              { label: "No equipment is used in the hotel that uses fossil fuels such as lawn mowers or gas terrace heaters", points: 1 ,answerCount:1},
              { label: "The hotel uses Diesel/Petrol lawn mower", points: 0 ,answerCount:1},
              { label: "Gas Terrace heaters are used in rooftop and/or outside areas such as bar(s) and restaurant(s)", points: 0 ,answerCount:1},
              { label: "Other fossil fuel equipment not listed used", points: 0, other: true ,answerCount:1},
            ]
          }
        ]
      },
      {
        categoryId: "S1-C4",
        categoryName: "Shuttle & Transfer services",
        questions: [
          {
            questionId: 4,
            text: "4. Select the answer that best applies, regarding shuttle and/or transfer services offered to guests.",
            helperText: "(Select only one answer)", 
            type: "single",
            options: [
              { label: "The hotel does not have owned or contracted shuttle services for guests to travel from hotel to nearest airport", points: 1 ,answerCount:1},
              { label: "The hotel owns/contracts shuttle buses/vans for guests to travel from hotel to nearest airport. These vehicles run on fossil fuels such as Petrol/Diesel", points: 0 ,answerCount:1},
              { label: "The hotel owns/contracts shuttle buses/vans for guests to travel from hotel to nearest airport but only 100% Electric vehicles are used.", points: 0,answerCount:1 }
            ]
          }
        ]
      }
    ]
  },

  2: {
    name: "Scope 2. Indirect Emissions",
    icon: "⚡",
    maxPoints: 9,
    maxQuestions: 4,
    categories: [
      {
        categoryId: "S2-C1",
        categoryName: "Purchased Electricity",
        questions: [
          {
            questionId: 5,
            text: "5. Select the answer that best applies, regarding purchased electricity.",
            helperText: "(Select only one answer)", 
            type: "single",
            options: [
              { label: "Hotel has renewable electricity contract for 100% electrical annual consumption", points: 2 ,answerCount:1},
              { label: "Hotel has a **{{tooltip:PPA contract|A PPA is a Power Purchasing Contract where the supplier provides a certificate to prove 100% of the electricity supplied is from renewables sources.}}** for 100% renewable electricity", points: 2 ,answerCount:1},
              { label: "Hotel purchases energy certificates (i.e. GOOs, RECs, IRECS) for 100% electical annual comsumption", points: 2 ,answerCount:1},
              { label: "Hotel purchases energy certificates (i.e. GOOs, RECs, IRECS) for less than 100% of the electical annual comsumption", points: 1,answerCount:1 },
              { label: "Hotel does not purchase renewable electricity", points: 0,answerCount:1 },
              { label: "I am not sure", points: 0 ,answerCount:1}
            ]
          }
        ]
      },
      {
        categoryId: "S2-C2",
        categoryName: "{{tooltip:District Purchased Services|Also known as City Heating or Cooling. Large network of underground pipes that provide heating/cooling to the hotel.}}",
        questions: [
          {
            questionId: 6,
            text: "6. Select the answer that best applies.",
            helperText: "(Select only one answer)", 
            type: "single",
            options: [
              { label: "Not applicable: The hotel does not purchase neither District Heating and/or Cooling", points: 1 ,answerCount:1},
              { label: "Yes: The hotel purchases District Heating", points: 0 ,answerCount:1},
              { label: "Yes: The hotel purchases District Cooling", points: 0 ,answerCount:1},
              { label: "Yes: The hotel purchases both District Heating & Cooling", points: 0 ,answerCount:1}
            ]
          },
          {
            questionId: 7,
            text: "6.1  If you answered yes on previous question, Select the answer that best applies.",
            helperText: "(Select only one answer)", 
            type: "single",
            options: [
              { label: "90% or more of the energy mix is from renewable sources", points: 1 ,answerCount:1},
              { label: "less than 90% of the energy mix is from renewable sources", points: 0 ,answerCount:1},
              { label: "I am not sure. The name of the supplier is", points: 0, other: true, answerCount:1}
            ]
          }
        ]
      },
      {
        categoryId: "S2-C3",
        categoryName: "Onsite Renewable Energy",
        questions: [
          {
            questionId: 8,
            text: "7. Select all answers that apply, regarding generating renewable energy produced in the hotel. ",
            helperText: "(Select multiple options)", 
            type: "multi",
            options: [
              { label: "Solar or heat pumps for HVAC or water heating system", points: 2 ,answerCount:1},
              { label: "Solar power for electricity generation", points: 1 ,answerCount:1},
              { label: "Biomass used for biogas in the kitchen   ", points: 1 ,answerCount:1},
              { label: "Other", points: 1, other: true },
              { label: "The hotel does not yet have any renewable energy system installed", points: 0 ,answerCount:1}
            ]
          }
        ]
      },
      {
        categoryId: "S2-C4",
        categoryName: "Building Certification",
        questions: [
          {
            questionId: 9,
            text: "8. Select all answers that apply, regarding green building certifications. NOTE: Greenkey or similar eco-labels are not considered as green building certifications.",
            helperText: "(Select multiple options)", 
            type: "multi",
            options: [
              { label: "BREEAM Outstanding", points: 2 ,answerCount:1},
              { label: "BREEAM Excellent to Very Good", points: 1 ,answerCount:1},
              { label: "BREEAM Other levels", points: 0 ,answerCount:1},
              { label: "EDGE Zero Carbon", points: 2 ,answerCount:1},
              { label: "EDGE 40", points: 2 ,answerCount:1},
              { label: "EDGE 20", points: 1  ,answerCount:1},
              { label: "GreenStar, DGNB, or other green building certifications", points: 1 ,answerCount:1},
              { label: "LEED Zero", points: 2 ,answerCount:1},
              { label: "LEED Platinum", points: 2 ,answerCount:1},
              { label: "LEED Gold ", points: 1 ,answerCount:1},
              { label: "LEED Other levels", points: 0 ,answerCount:1},
              { label: "The green building certification is not listed however I can provide the name and level ", points: 1 ,other: true ,answerCount:1},
              { label: "The green building certification is not listed and I do not know the certification name", points: 1  ,answerCount:1},
              { label: "The hotel does not have a green building certification", points: 0 , answerCount:1 }
            ]
          }
        ]
      }
    ]
  },

  3: {
    name: "Scope 3. Operational Emissions",
    icon: "🌍",
    maxPoints: 15,
    maxQuestions: 9,
    categories: [
      {
        categoryId: "S3-C1",
        categoryName: "Guestroom Services",
        questions: [
          {
            questionId: 10,
            text: "9. Select the answer that best applies, regarding Bathroom amenities.",
            helperText: "(Select multiple options)", 
            type: "multi",
            options: [
              { label: "Hotel has bulk amenities dispensers in the guest bathroom, and recycles dispenser bottles", points: 2 ,answerCount:1},
              { label: "{{tooltip:Hotel has bulk amenities dispensers in the guest bathroom, but does not yet recycle them|To start recycling the dispenser bottles, reach out to responsiblebusiness@radissonhotels.com}}", points: 1 ,answerCount:1},
              { label: "Hotel has mini amenities in the guest bathroom", points: 0 ,answerCount:1}
            ]
          },
          {
            questionId: 11,
            text: "10. Select the answer that best applies, regarding recycling bins in guestrooms. ",
            helperText: "(Select only one answer)", 
            type: "single",
            options: [
              { label: "Guestrooms have 3-way recycling bins, separating general waste, food waste, and recyclables", points: 2 ,answerCount:1},
              { label: "Guestrooms have 3-way recycling bins, separating food waste, plastic and paper", points: 2 ,answerCount:1},
              { label: "Guestrooms have 3-way recycling bins, separating other waste streams not identified", points: 1 ,answerCount:1},
              { label: "Guestrooms have 2-way recycling bins, separating recylables from organic or general waste", points: 1 ,answerCount:1},
              { label: "There are no recycling bins in the guestrooms.", points: 0 ,answerCount:1}
              
            ]
          },
          {
            questionId: 12,
            text: "11. Select the answer that best applies, regarding the material of water bottles in guestrooms.",
            helperText: "(Select only one answer)", 
            type: "single",
            options: [
              { label: "Guestrooms offer glass bottles", points: 2 ,answerCount:1},
              { label: "Guestrooms  offer Tetra pack cartons or cans", points: 1 ,answerCount:1},
              { label: "Guestrooms offer 100% plant-based bottle ", points: 1 ,answerCount:1},
              { label: "Guestrooms offer 100% Recycled Plastic Water bottles", points: 0 ,answerCount:1},
              { label: "Plastic Water bottles are offered", points: 0 ,answerCount:1},
              { label: "The hotel does not offer water in guestrooms", points: 0 ,answerCount:1}
            ]
          },
          {
            questionId: 13,
            text: "12. {{tooltip:Has the hotel implemented the STAY e-Concierge app?|To implement the STAY app, reach out to alexandra@stay-app.com}}",
            type: "yesno",
            options: [
              { label: "Yes", points: 1 ,answerCount:1},
              { label: "No", points: 0 ,answerCount:1}
            ]
          }
        ]
      },
      {
        categoryId: "S3-C2",
        categoryName: "Waste Management",
        questions: [
          {
            questionId: 14,
            text: "13. Does the waste management company ensure zero waste goes to landfill?",
            helperText: "(Select only one answer)", 
            type: "single",
            options: [
              { label: "Yes", points: 1 ,answerCount:1},
              { label: "No", points: 0 ,answerCount:1},
              { label: "I do not know. The name of the supplier is", points: 0 , other: true, answerCount:1}
            ]
          },
          {
            questionId: 15,
            text: "13.1 Does the kitchen measure food waste ? ",
            helperText: "(Select only one answer)", 
            type: "single",
            options: [
              { label: "Yes - Through eSmiley, Orbisk or Winnow", points: 1 ,answerCount:1},
              { label: "Yes - Through a waste measuring service not listed", points: 1 ,other: true ,answerCount:1},
              { label: "{{tooltip:No|To start, reach out responsiblebusiness@radissonhotels.com}}", points: 0  ,answerCount:1}
            ]
          },
          {
            questionId: 16,
            text: "13.2 Does the hotel offer recycling bins in Public areas?",
            helperText: "(Select only one answer)", 
            type: "single",
            options: [
              { label: "Yes: Outside M&E, Reception and Breakout are, and 1 per guestfloor", points: 2 ,answerCount:1 },
              { label: "Yes: Outside M&E, Reception and Breakout areas if applicable", points: 1 ,answerCount:1 },
              { label: "Yes: Outside M&E and Reception ", points: 1 ,answerCount:1},
              { label: "Yes: Outside M&E or Reception Only", points: 1 ,answerCount:1 },
              { label: "No", points: 0  ,answerCount:1}
            ]
          }
        ]
      },
      {
        categoryId: "S3-C3",
        categoryName: "Suppliers: Outsourced Laundry",
        questions: [
           {
            questionId: 17,
            text: "14. Does your hotel have Outsourced Laundry? ",
            type: "yesno",
            options: [
              { label: "Yes", points: 1 ,answerCount:1},
              { label: "No", points: 0 ,answerCount:1},
            ]
          },
          {
            questionId: 18,
            text: "14.1  Select from the answers below, the option that best describes the transportation services from your laundry supplier. ",
            helperText: "(Select only one answer)", 
            type: "single",
            options: [
              { label: "Goods are delivered via EV trucks/vans", points: 1 ,answerCount:1},
              { label: "Goods are delivered via other renewable powered trucks/vans", points: 1,other: true ,answerCount:1},
              { label: "Goods are delivered via diesel or any other {{tooltip:fossil fuel trucks/vans|Fossil fuel trucks/vans use petrol or diesel.}}", points: 0 ,answerCount:1},
              { label: "I am not sure/ I do not know",points: 0 ,answerCount:1}
            ]
          },
          {
            questionId: 19,
            text: "14.2 Does your laundry supplier use an energy efficient factory?",
            helperText: "(Select only one answer)", 
            type: "single",
            options: [
              { label: "Yes", points: 1 ,answerCount:1},
              { label: "No", points: 0 ,answerCount:1},
              { label: "I am not sure/ I do not know", points: 0 ,answerCount:1}
            ]
          },
          {
            questionId: 20,
            text: "14.3  Select from the answers below, the option that best describes the energy used by your laundry supplier.",
            helperText: "(Select only one answer)", 
            type: "single",
            options: [
              { label: "The laundry facility is run entriley on 100% renewable energy", points: 2 ,answerCount:1},
              { label: "The laundry facility uses a mixed of renewable energy and fossil fuel energy", points: 1 ,answerCount:1},
              { label: "I am not sure/ I do not know. The name of the supplier is", points: 0, other: true, answerCount:1}
            ]
          }
        ]
      },
      {
        categoryId: "S3-C4",
        categoryName: "Food and Beverage",
        questions: [
          {
            questionId:21,
            text: "15. The hotel has implemented services for F&B footprint calculations",
            helperText: "(Select only one answer)", 
            type: "single",
            options: [
              { label: "Yes: Through Klimato", points: 0 ,answerCount:1},
              { label: "Yes: Through a different supplier", points: 0,other: true ,answerCount:1},
              { label: "{{tooltip:No|To start, reach out responsiblebusiness@radissonhotels.com}}", points: 0 ,answerCount:1}
            ]
          }
        ]
      }
    ]
  }
};